import { render, staticRenderFns } from "./HotwordConfig.vue?vue&type=template&id=54f30296&scoped=true&"
import script from "./HotwordConfig.vue?vue&type=script&lang=js&"
export * from "./HotwordConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f30296",
  null
  
)

export default component.exports